import React, {useEffect, useState} from "react";
import {
  TextField,
  Button,
  Slider,
  Typography,
  Rating,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { YellowStarFilled, YellowStarLine } from "../../utils/Icons";
import "./surveyForm.scss";
import SuccessIcon from "../../utils/Icons/SuccessIcon";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { createSurveyRequest } from "../../store/Survey/actions";
import messages from "../../assets/locale/messages";

const SurveyForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.locale.lang);
  const { surveyForm } = messages[lang];

  const { error, success } = useSelector((state) => state.surveyReducer);

  const [modalOpen, setModalOpen] = useState(false);

  const [formData, setFormData] = useState({
    event: "",
    serviceQualityImportance: 0,
    serviceQualityScore: 0,
    speedResponseImportance: 0,
    speedResponseScore: 0,
    complianceImportance: 0,
    complianceScore: 0,
    definingRequestsImportance: 0,
    definingRequestsScore: 0,
    financeDeptImportance: 0,
    financeDeptScore: 0,
    priceTermsImportance: 0,
    priceTermsScore: 0,
    complaintResolutionImportance: 0,
    complaintResolutionScore: 0,
    complaintWayImportance: 0,
    complaintWayScore: 0,
    attentionDetailImportance: 0,
    attentionDetailScore: 0,
    suggestions: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleEventChange = (e) => {
    const { value } = e.target;
    setFormData({
      event: value,
      serviceQualityImportance: 0,
      serviceQualityScore: 0,
      speedResponseImportance: 0,
      speedResponseScore: 0,
      complianceImportance: 0,
      complianceScore: 0,
      definingRequestsImportance: 0,
      definingRequestsScore: 0,
      financeDeptImportance: 0,
      financeDeptScore: 0,
      priceTermsImportance: 0,
      priceTermsScore: 0,
      complaintResolutionImportance: 0,
      complaintResolutionScore: 0,
      complaintWayImportance: 0,
      complaintWayScore: 0,
      attentionDetailImportance: 0,
      attentionDetailScore: 0,
      suggestions: "",
    });
  };

  // Calculate the total score as a percentage
  // const calculateTotal = () => {
  //     const totalScore = Object.values(formData).reduce((acc, value) => {
  //         if (typeof value === 'number' && value !== 0) {
  //             return acc + value;
  //         }
  //         return acc;
  //     }, 0);
  //     const maxScore = 45; // Maximum score based on 5 stars x 9 items
  //     return (totalScore / maxScore) * 100 || 0;
  // };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const attributes = [
      {
        name: "Service Quality",
        importance: formData.serviceQualityImportance,
        score: formData.serviceQualityScore,
      },
      {
        name: "Speed Response",
        importance: formData.speedResponseImportance,
        score: formData.speedResponseScore,
      },
      {
        name: "Compliance",
        importance: formData.complianceImportance,
        score: formData.complianceScore,
      },
      {
        name: "Defining Requests",
        importance: formData.definingRequestsImportance,
        score: formData.definingRequestsScore,
      },
      {
        name: "Finance Department",
        importance: formData.financeDeptImportance,
        score: formData.financeDeptScore,
      },
      {
        name: "Price Terms",
        importance: formData.priceTermsImportance,
        score: formData.priceTermsScore,
      },
      {
        name: "Complaint Resolution",
        importance: formData.complaintResolutionImportance,
        score: formData.complaintResolutionScore,
      },
      {
        name: "Complaint Way",
        importance: formData.complaintWayImportance,
        score: formData.complaintWayScore,
      },
      {
        name: "Attention to Detail",
        importance: formData.attentionDetailImportance,
        score: formData.attentionDetailScore,
      },
    ];

    const totalScore = attributes.reduce(
      (acc, attribute) => acc + attribute.importance * attribute.score,
      0
    );
    const scorePercentage = (
      (totalScore / (attributes.length * 5 * 5)) *
      100
    ).toFixed(2);

    const payload = {
      event_id: id,
      data: {
        survey_id: 1,
        total_score: totalScore,
        score_percentage: `${scorePercentage}%`,
        attributes: attributes.map((attribute) => ({
          attribute_name: attribute.name,
          importance: attribute.importance,
          rating: attribute.score,
          weighted_score: attribute.importance * attribute.score,
        })),
        comments: formData.suggestions,
      },
    };

    dispatch(createSurveyRequest(payload));
    setTimeout(() => {
      setModalOpen(false);
      handleEventChange({ target: { value: "" } });
    }, 2000);
  };

  useEffect(() => {
    if (success) {
      setModalOpen(true);
      setTimeout(() => {
        setModalOpen(false);
        handleEventChange({ target: { value: "" } });
      }, 2000);
    } else if (error && error !== 422) {
      setModalOpen(true);
      setTimeout(() => {
        setModalOpen(false);
      }, 2000);
    }
  }, [success, error]);

  const isFormValid = () => {
    return (
      formData.event &&
      formData.serviceQualityImportance !== 0 &&
      formData.serviceQualityScore !== 0 &&
      formData.speedResponseImportance !== 0 &&
      formData.speedResponseScore !== 0 &&
      formData.complianceImportance !== 0 &&
      formData.complianceScore !== 0 &&
      formData.definingRequestsImportance !== 0 &&
      formData.definingRequestsScore !== 0 &&
      formData.financeDeptImportance !== 0 &&
      formData.financeDeptScore !== 0 &&
      formData.priceTermsImportance !== 0 &&
      formData.priceTermsScore !== 0 &&
      formData.complaintResolutionImportance !== 0 &&
      formData.complaintResolutionScore !== 0 &&
      formData.complaintWayImportance !== 0 &&
      formData.complaintWayScore !== 0 &&
      formData.attentionDetailImportance !== 0 &&
      formData.attentionDetailScore !== 0
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* Modal */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        className="success-modal"
      >
        <Box
          display="flex"
          justifyContent="center"
          mt={2}
          className="success-icon"
        >
          <SuccessIcon />
        </Box>

        <DialogContent>
          <DialogTitle>
            {surveyForm.thankyoumessage}
          </DialogTitle>
          <Typography>
            {surveyForm.contributionMessage}
          </Typography>
        </DialogContent>
      </Dialog>

      {/* Service Quality */}
      <div className="grid-container">
        <div className="grid-item">
          <Typography variant="h6">
            <span className="count">{surveyForm.count.count1}</span>
            {surveyForm.serviceQuality}
          </Typography>

          <Typography>{surveyForm.importance}</Typography>
          <Slider
            value={formData.serviceQualityImportance}
            onChange={(e, value) =>
              setFormData({ ...formData, serviceQualityImportance: value })
            }
            valueLabelDisplay="auto"
            step={1}
            marks
            min={0}
            max={5}
          />
          <Typography>{surveyForm.score}</Typography>
          <Rating
            name="serviceQualityScore"
            value={formData.serviceQualityScore}
            onChange={(e, newValue) =>
              setFormData({ ...formData, serviceQualityScore: newValue })
            }
            max={5}
            icon={<YellowStarFilled />}
            emptyIcon={<YellowStarLine />}
          />
        </div>
        {/* Speed of Response */}
        <div className="grid-item">
          <Typography variant="h6">
            {" "}
            <span className="count">{surveyForm.count.count2}</span>
            {surveyForm.speedResponse}
          </Typography>
          <Box>
            <Typography>{surveyForm.importance}</Typography>
            <Slider
              value={formData.speedResponseImportance}
              onChange={(e, value) =>
                setFormData({ ...formData, speedResponseImportance: value })
              }
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={5}
            />
            <Typography>{surveyForm.score}</Typography>
            <Rating
              name="speedResponseScore"
              value={formData.speedResponseScore}
              onChange={(e, newValue) =>
                setFormData({ ...formData, speedResponseScore: newValue })
              }
              max={5}
              icon={<YellowStarFilled />}
              emptyIcon={<YellowStarLine />}
              size="large"
            />
          </Box>
        </div>
        {/* Compliance to Contractual Obligations */}
        <div className="grid-item">
          <Typography variant="h6">
            <span className="count">{surveyForm.count.count3}</span>
            {surveyForm.compliance}
          </Typography>
          <Box>
            <Typography>{surveyForm.importance}</Typography>
            <Slider
              value={formData.complianceImportance}
              onChange={(e, value) =>
                setFormData({ ...formData, complianceImportance: value })
              }
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={5}
            />
            <Typography>{surveyForm.score}</Typography>
            <Rating
              name="complianceScore"
              value={formData.complianceScore}
              onChange={(e, newValue) =>
                setFormData({ ...formData, complianceScore: newValue })
              }
              max={5}
              icon={<YellowStarFilled />}
              emptyIcon={<YellowStarLine />}
            />
          </Box>
        </div>
        {/* Attention to detail and thoriughness */}
        <div className="grid-item">
          <Typography variant="h6">
            <span className="count">{surveyForm.count.count4}</span> {surveyForm.attentionDetail}
          </Typography>
          <Box>
            <Typography>{surveyForm.importance}</Typography>
            <Slider
              value={formData.attentionDetailImportance}
              onChange={(e, value) =>
                setFormData({ ...formData, attentionDetailImportance: value })
              }
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={5}
            />
            <Typography>{surveyForm.score}</Typography>
            <Rating
              name="attentionDetailScore"
              value={formData.attentionDetailScore}
              onChange={(e, newValue) =>
                setFormData({ ...formData, attentionDetailScore: newValue })
              }
              max={5}
              icon={<YellowStarFilled />}
              emptyIcon={<YellowStarLine />}
            />
          </Box>
        </div>

        {/* Understanding and Help with Defining Requests */}
        <div className="grid-item">
          <Typography variant="h6">
            <span className="count">{surveyForm.count.count5}</span>{surveyForm.definingRequests}
          </Typography>
          <Box>
            <Typography>{surveyForm.importance}</Typography>
            <Slider
              value={formData.definingRequestsImportance}
              onChange={(e, value) =>
                setFormData({ ...formData, definingRequestsImportance: value })
              }
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={5}
            />
            <Typography>{surveyForm.score}</Typography>
            <Rating
              name="definingRequestsScore"
              value={formData.definingRequestsScore}
              onChange={(e, newValue) =>
                setFormData({ ...formData, definingRequestsScore: newValue })
              }
              max={5}
              icon={<YellowStarFilled />}
              emptyIcon={<YellowStarLine />}
            />
          </Box>
        </div>
        {/* Promptness and Cooperation of Administrative Department */}
        <div className="grid-item">
          <Typography variant="h6">
            <span className="count">{surveyForm.count.count6}</span>{surveyForm.financeDept}
          </Typography>
          <Box>
            <Typography>{surveyForm.importance}</Typography>
            <Slider
              value={formData.financeDeptImportance}
              onChange={(e, value) =>
                setFormData({ ...formData, financeDeptImportance: value })
              }
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={5}
            />
            <Typography>{surveyForm.score}</Typography>
            <Rating
              name="financeDeptScore"
              value={formData.financeDeptScore}
              onChange={(e, newValue) =>
                setFormData({ ...formData, financeDeptScore: newValue })
              }
              max={5}
              icon={<YellowStarFilled />}
              emptyIcon={<YellowStarLine />}
            />
          </Box>
        </div>
        {/* Price/Terms of Payments */}
        <div className="grid-item">
          <Typography variant="h6">
            <span className="count">{surveyForm.count.count7}</span>{surveyForm.priceTerms}
          </Typography>
          <Box>
            <Typography>{surveyForm.importance}</Typography>
            <Slider
              value={formData.priceTermsImportance}
              onChange={(e, value) =>
                setFormData({ ...formData, priceTermsImportance: value })
              }
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={5}
            />
            <Typography>{surveyForm.score}</Typography>
            <Rating
              name="priceTermsScore"
              value={formData.priceTermsScore}
              onChange={(e, newValue) =>
                setFormData({ ...formData, priceTermsScore: newValue })
              }
              max={5}
              icon={<YellowStarFilled />}
              emptyIcon={<YellowStarLine />}
            />
          </Box>
        </div>
        {/* Speed of Complaint Resolution */}
        <div className="grid-item">
          <Typography variant="h6">
            <span className="count">{surveyForm.count.count8}</span>{surveyForm.complaintResolution}
          </Typography>
          <Box>
            <Typography>{surveyForm.importance}</Typography>
            <Slider
              value={formData.complaintResolutionImportance}
              onChange={(e, value) =>
                setFormData({
                  ...formData,
                  complaintResolutionImportance: value,
                })
              }
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={5}
            />
            <Typography>{surveyForm.score}</Typography>
            <Rating
              name="complaintResolutionScore"
              value={formData.complaintResolutionScore}
              onChange={(e, newValue) =>
                setFormData({ ...formData, complaintResolutionScore: newValue })
              }
              max={5}
              icon={<YellowStarFilled />}
              emptyIcon={<YellowStarLine />}
            />
          </Box>
        </div>
        {/* Way of Resolving Complaints */}
        <div className="grid-item">
          <Typography variant="h6">
            <span className="count">{surveyForm.count.count9}</span>{surveyForm.complaintWay}
          </Typography>
          <Box>
            <Typography>{surveyForm.importance}</Typography>
            <Slider
              value={formData.complaintWayImportance}
              onChange={(e, value) =>
                setFormData({ ...formData, complaintWayImportance: value })
              }
              valueLabelDisplay="auto"
              step={1}
              marks
              min={0}
              max={5}
            />
            <Typography>{surveyForm.score}</Typography>
            <Rating
              name="complaintWayScore"
              value={formData.complaintWayScore}
              onChange={(e, newValue) =>
                setFormData({ ...formData, complaintWayScore: newValue })
              }
              max={5}
              icon={<YellowStarFilled />}
              emptyIcon={<YellowStarLine />}
            />
          </Box>
        </div>
      </div>
      {/* Total Score */}
      {/* <div className="total-score-wrapper">
                <div className="title">
                    <Typography variant="h6">Total</Typography>
                </div>
                <div className="score">
                    <span>{surveyForm.score}</span>
                    <Typography variant="h6"> {calculateTotal().toFixed(2)}%</Typography>
                </div>

            </div> */}
      {/* Suggestions/Comments */}

      <div
        className="suggestion-comments-wrapper"
        style={{ marginTop: "20px" }}
      >
        <div className="title">
          <Typography variant="h5">{surveyForm.suggestionsComments}</Typography>
        </div>
        <TextField
          label={surveyForm.textFieldLabel}
          name="suggestions"
          value={formData.suggestions}
          onChange={handleChange}
          fullWidth
          multiline
          rows={4}
          margin="normal"
        />
      </div>

      <div className="submit-button-container">
        <Button
          variant="contained"
          color="primary"
          type="submit"
          size="large"
          disabled={isFormValid()}
        >
          {surveyForm.submit}
        </Button>
      </div>
    </form>
  );
};

export default SurveyForm;
